// Shared render utilities
// Used by message-content.js and index.js

export function generateId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export const PHRASES = [
  "Something you've been carrying is ready to move.",
  "What would you build today if you knew it would work?",
  "Shift starts with one honest sentence.",
  "The thing you keep circling — bring it here.",
  "What's the problem underneath the problem?",
  "Start anywhere. The right thread will surface.",
  "What needs to be said out loud today?",
  "Every good thing started as a conversation.",
  "Bring the unfinished thing.",
  "What would you attempt if the outcome was already decided?",
  "The question you haven't asked yet — ask it.",
  "Something small today could compound into something large.",
  "Shift happens one honest exchange at a time.",
  "What are you building toward that you haven't told anyone?",
  "The gap between knowing and doing starts here.",
  "Bring the thing you've been thinking about since yesterday.",
  "What decision is waiting for you to make it?",
  "The best ideas arrive in conversation.",
  "What would change if you said the actual thing?",
  "Start with what's true right now.",
  "A single clear thought can reorganize everything.",
  "What's the version of this you haven't tried yet?",
  "Bring your best problem.",
  "The next step is always visible from inside the conversation.",
  "What do you know that you haven't acted on yet?",
  "Shift what you see — then everything else moves.",
  "What's the real question underneath this one?",
  "Say it plainly. That's enough to start.",
  "Every breakthrough was a conversation first.",
  "What would you build if you started today?",
  "The answer is usually closer than the question suggests.",
  "What's been sitting with you that hasn't been said?",
  "Bring something real. That's all it takes.",
  "The work starts when you name what it actually is.",
  "What shifts when you say it out loud?",
  "One good conversation changes the trajectory.",
  "What's the thing you almost didn't bring?",
  "The clearer you get here, the cleaner it gets everywhere.",
  "What are you close to that you can't quite see yet?",
  "Bring the thing. Not the version of it — the thing."
];

export function getPhrase() {
  return PHRASES[Math.floor(Math.random() * PHRASES.length)];
}

// S Animation — geometric S, dots bottom to top


// Break Timer overlay

// ── Code block rendering — no hooks, direct DOM for copy feedback ────────────
export const LANG_LABELS = {
  js:'JavaScript',javascript:'JavaScript',jsx:'JSX',
  ts:'TypeScript',typescript:'TypeScript',tsx:'TSX',
  py:'Python',python:'Python',
  sql:'SQL',json:'JSON',json5:'JSON',
  sh:'Shell',bash:'Shell',zsh:'Shell',
  css:'CSS',html:'HTML',xml:'XML',
  md:'Markdown',markdown:'Markdown',
  txt:'Text',text:'Text',
};
export const LANG_EXT = {
  js:'js',javascript:'js',jsx:'jsx',
  ts:'ts',typescript:'ts',tsx:'tsx',
  py:'py',python:'py',
  sql:'sql',json:'json',json5:'json',
  sh:'sh',bash:'sh',zsh:'sh',
  css:'css',html:'html',xml:'xml',
  md:'md',markdown:'md',
  txt:'txt',
};

export function downloadCode(code, lang) {
  const ext = LANG_EXT[lang] || 'txt';
  const blob = new Blob([code], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'shift-output.' + ext;
  a.click();
  URL.revokeObjectURL(url);
}

export function renderCodeBlock(code, lang, blockKey, isMobile, onHtmlBlock) {
  const label = LANG_LABELS[lang] || (lang ? lang.toUpperCase() : 'Code');
  const lineCount = code.split('\n').length;
  const isHtml = lang === 'html' || lang === 'htm';

  function handleCopy(e) {
    const btn = e.currentTarget;
    navigator.clipboard.writeText(code).then(() => {
      btn.textContent = 'copied';
      btn.style.color = '#4a7a6d';
      setTimeout(() => { btn.textContent = 'copy'; btn.style.color = '#555'; }, 1800);
    });
  }

  function handlePreview() {
    if (onHtmlBlock) onHtmlBlock(code);
  }

  return (
    <div key={blockKey} style={{ margin: '14px 0', borderRadius: '6px', overflow: 'hidden', border: '1px solid #2a2a2a', background: '#0d0d0d' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '7px 14px', background: '#161616', borderBottom: '1px solid #222' }}>
        <span style={{ color: '#666', fontSize: '11px', fontFamily: 'monospace', letterSpacing: '0.06em' }}>{label}</span>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          {isHtml && onHtmlBlock && (
            <button onClick={handlePreview}
              style={{ background: 'none', border: '1px solid #2a3a2a', cursor: 'pointer', color: '#4a7a4a', fontSize: '11px', fontFamily: 'Georgia, serif', letterSpacing: '0.06em', padding: '2px 8px', borderRadius: '3px' }}
              onMouseEnter={e => { e.currentTarget.style.background = '#1a2a1a'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'none'; }}>
              ▶ preview
            </button>
          )}
          <button onClick={handleCopy}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#555', fontSize: '11px', fontFamily: 'Georgia, serif', letterSpacing: '0.06em', padding: '2px 6px', borderRadius: '3px' }}
            onMouseEnter={e => e.currentTarget.style.color = '#888'}
            onMouseLeave={e => e.currentTarget.style.color = '#555'}>
            copy
          </button>
          {lineCount > 20 && (
            <button onClick={() => downloadCode(code, lang)}
              style={{ background: 'none', border: '1px solid #2a2a2a', cursor: 'pointer', color: '#555', fontSize: '11px', fontFamily: 'Georgia, serif', letterSpacing: '0.06em', padding: '2px 8px', borderRadius: '3px' }}
              onMouseEnter={e => { e.currentTarget.style.color = '#888'; e.currentTarget.style.borderColor = '#444'; }}
              onMouseLeave={e => { e.currentTarget.style.color = '#555'; e.currentTarget.style.borderColor = '#2a2a2a'; }}>
              ↓ download
            </button>
          )}
        </div>
      </div>
      <pre style={{ margin: 0, padding: '16px', overflowX: 'auto', fontSize: '13px', lineHeight: '1.65', fontFamily: "'Courier New', Courier, monospace", color: '#c8c8c8', background: '#0d0d0d', whiteSpace: 'pre' }}>
        <code>{code}</code>
      </pre>
    </div>
  );
}

export function renderInlineCode(text, key) {
  if (!text) return null;
  // Split on backtick inline code AND newlines — newlines become <br> since pre-wrap is removed
  const segments = text.split(/(`[^`\n]+`|\n)/g);
  return (
    <span key={key}>
      {segments.map((seg, si) => {
        if (seg === '\n') return <br key={si} />;
        if (seg && seg.startsWith('`') && seg.endsWith('`') && seg.length > 2) {
          return (
            <code key={si} style={{ fontFamily: "'Courier New', monospace", fontSize: '0.88em', background: '#1e1e2a', border: '1px solid #2a2a2a', borderRadius: '3px', padding: '1px 5px', color: '#c8a96e' }}>
              {seg.slice(1, -1)}
            </code>
          );
        }
        return <span key={si}>{seg}</span>;
      })}
    </span>
  );
}

export function renderMessageContent(text, msgIndex, isMobile, onHtmlBlock) {
  if (!text || typeof text !== 'string') return text;

  // Normalize line endings
  const normalized = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

  if (!normalized.includes('```')) return renderInlineCode(normalized, msgIndex + '-plain');

  // Split on ``` delimiter — even indexes are prose, odd indexes are code blocks
  const parts = normalized.split('```');

  if (parts.length < 3) {
    // Unclosed code block — model was cut off or still streaming.
    // If we have exactly 2 parts, the second is an open code block — render it anyway.
    if (parts.length === 2) {
      const newlineIdx = parts[1].indexOf('\n');
      if (newlineIdx >= 0) {
        const lang = parts[1].slice(0, newlineIdx).trim().toLowerCase();
        const code = parts[1].slice(newlineIdx + 1);
        const result = [];
        if (parts[0]) result.push(renderInlineCode(parts[0], msgIndex + '-t-0'));
        result.push(renderCodeBlock(code, lang, msgIndex + '-cb-0', isMobile, onHtmlBlock));
        return <span>{result}</span>;
      }
    }
    return renderInlineCode(normalized, msgIndex + '-plain');
  }

  const result = [];

  parts.forEach((part, i) => {
    if (i % 2 === 0) {
      // Plain text segment
      if (part) result.push(renderInlineCode(part, msgIndex + '-t-' + i));
    } else {
      // Code block — first line is language tag, rest is code
      const newlineIdx = part.indexOf('\n');
      if (newlineIdx < 0) {
        result.push(renderInlineCode(part, msgIndex + '-t-' + i));
        return;
      }
      const lang = part.slice(0, newlineIdx).trim().toLowerCase();
      const code = part.slice(newlineIdx + 1).replace(/\n$/, '');
      result.push(renderCodeBlock(code, lang, msgIndex + '-cb-' + i, isMobile, onHtmlBlock));
    }
  });

  return <span>{result}</span>;
}
// ── End CodeBlock ────────────────────────────────────────────────────────────

// ── End MessageContent ────────────────────────────────────────────────────────

export function isFileRequest(text) {
  const lower = text.toLowerCase();
  const triggers = [
    // spreadsheet / excel
    'build me a spreadsheet', 'create a spreadsheet', 'make a spreadsheet',
    'build me an excel', 'create an excel', 'make an excel',
    'build a spreadsheet', 'build an excel', 'build me a tracker',
    'create a tracker', 'make a tracker', 'build a tracker',
    'build me a budget', 'create a budget', 'make a budget',
    'build a budget', 'create a template', 'build a template',
    'make a template', 'build me a template', 'create a schedule',
    'build a schedule', 'make a schedule', 'build me a schedule',
    'spreadsheet for', 'excel for', 'tracker for',
    // word doc / document
    'build me a document', 'create a document', 'make a document',
    'build a document', 'write a document', 'build me a report',
    'create a report', 'make a report', 'write a report', 'build a report',
    'build me a proposal', 'create a proposal', 'write a proposal',
    'build a proposal', 'build me a plan', 'create a plan doc',
    'write a plan', 'build me a memo', 'create a memo', 'write a memo',
    'build me a letter', 'write a letter', 'create a letter',
    'build me a word doc', 'create a word doc', 'make a word doc',
    'write me a', 'draft me a', 'create a brief', 'build a brief',
    'document for', 'report for', 'proposal for'
  ];
  return triggers.some(t => lower.includes(t));
}

export function getEmotionalPlaceholder(register, aiName) {
  const phrases = {
    energized:   ['What do you want to shift today',         'The energy is here — where does it go',      'You\'re in it — what moves next'],
    clear:       ['Something is clear — say it before it fades', 'You already know — just say it',         'Clarity is momentum — use it now'],
    focused:     ['Locked in. What moves',                   'The thread is alive — follow it',            'Go'],
    scattered:   ['Start anywhere — the thread finds itself','One thing. The loudest one',                 'Give me one sentence — the rest follows'],
    tired:       ['Even one line is enough today',           'Light load today — what\'s on your mind',    'Slow and honest is still forward'],
    heavy:       ['You don\'t have to carry it alone',       'Say the thing that\'s sitting heaviest',     'No right way to start — just start'],
    anxious:     ['One thing at a time — what\'s first',     'Name the loudest thought right now',         'Let\'s slow it down — what\'s underneath'],
    flat:        ['You showed up — that\'s enough to start', 'Wherever you are is the right place to start','Small is fine today'],
    frustrated:  ['Say exactly what\'s true right now',      'No filter — what happened',                  'The frustration has information in it'],
    curious:     ['Follow that thread — where does it lead', 'That question is worth pulling on',          'Curiosity is the signal — go deeper'],
    resolved:    ['Something landed — what does it open up', 'You worked something through — what\'s next','What shifted — name it'],
    stuck:       ['Name exactly where the wall is',          'Let\'s look at the loop together',           'Stuck has a reason — let\'s find it'],
    neutral:     ['What\'s on your mind',                    'Tell me where you are today',                'What do you want to shift'],
  };
  const options = phrases[register] || phrases.neutral;
  return options[Math.floor(Math.random() * options.length)];
}

